import { useCallback, useMemo, useState } from 'react';
import { Box, InputBase, makeStyles } from '@material-ui/core';
import Dialog from '../../../../components/Dialog';
import LongRemark from '../../../../components/LongRemark';
import StatusBed from '../Icons/StatusBed';
import { getBedByCubicleIdAndPosition } from '../../../../utils/newBedStatusUtil';
import { NEW_BED_STATUS_LENGTH } from '../../../../comm/constant';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  input: {
    width: '50%',
    height: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  closeBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translate(35%,-35%)',
  },
  closeIcon: {
    fontSize: '2.8rem',
    color: '#7b80ff',
  },
}));

const FirstLinkedBed = ({ firstLinkObj, handleClose, cubicleList, handleFirstCreateLink }) => {
  const classes = useStyles();
  const [form, setForm] = useState({
    linkedBedNo: '',
    linkedId: null,
    linkeds: [],
  });

  const beds = useMemo(() => {
    let destinationBed;
    let sourceBed;
    if (firstLinkObj.type === 'Wait') {
      sourceBed = firstLinkObj.from.bed;
    } else {
      sourceBed = getBedByCubicleIdAndPosition(
        cubicleList,
        firstLinkObj.from.cubicleId,
        firstLinkObj.from.row,
        firstLinkObj.from.column
      );
    }

    destinationBed = getBedByCubicleIdAndPosition(
      cubicleList,
      firstLinkObj.to.cubicleId,
      firstLinkObj.to.row,
      firstLinkObj.to.column
    );

    setForm((o) => {
      return {
        ...o,
        linkedBedNo: destinationBed.bedNo,
        linkeds: [
          {
            bedNo: destinationBed.bedNo,
            bedStatusId: destinationBed.bedStatusId,
            ccWardCd: destinationBed.ccWardCd,
            status: destinationBed.status,
          },
          {
            bedNo: sourceBed.bedNo,
            bedStatusId: sourceBed.bedStatusId,
            ccWardCd: sourceBed.ccWardCd,
            status: sourceBed.status,
          },
        ],
      };
    });

    return {
      sourceBed,
      destinationBed,
    };
  }, [firstLinkObj, cubicleList]);

  const handleInputLinkedBedNo = useCallback((e) => {
    setForm((o) => ({
      ...o,
      linkedBedNo: e.target.value,
    }));
  }, []);

  const disabled = useMemo(() => {
    return !form.linkedBedNo;
  }, [form]);

  const handleSubmit = useCallback(() => {
    handleFirstCreateLink(form, beds.sourceBed, beds.destinationBed);
  }, [handleFirstCreateLink, form, beds]);

  return (
    <Dialog
      open={true}
      title="Linked Bed"
      confirm="Confirm"
      dialogfootStyle={{ paddingTop: '1.5rem', borderTop: 'solid 1px #e4e7eb', marginTop: '1.875rem' }}
      handleClose={handleClose}
      handleConfirm={handleSubmit}
      disabled={disabled}
    >
      <Box display="flex" flexDirection="column" gridGap="2.5rem">
        <Box display="flex" flexDirection="column" gridGap="0.5rem">
          <div className={classes.title}>Bed Number</div>
          <InputBase
            className={classes.input}
            value={form.linkedBedNo}
            onChange={handleInputLinkedBedNo}
            inputProps={{ maxLength: NEW_BED_STATUS_LENGTH.LINKED_BED_NAME }}
          />
        </Box>
        <Box display="flex" flexDirection="column" gridGap="2.5rem">
          <Box display="flex">
            <div className={classes.title}>Included Bed</div>
            <LongRemark content="Included Bed" />
          </Box>
          <Box display="flex" gridGap="2.5rem" flexWrap="wrap">
            {form.linkeds.map((item) => (
              <Box
                width="6.875rem"
                height="6.875rem"
                display="flex"
                justifyContent="center"
                alignItems="center"
                boxShadow="0 0 8px 0 rgba(125, 134, 169, 0.25)"
                borderRadius="8px"
                position="relative"
                key={item.bedStatusId}
              >
                <StatusBed
                  bedNo={item.bedNo}
                  ward={item.ccWardCd}
                  style={{
                    rootBg: '#fff',
                    bedNoFont: '#538fff',
                    rootBorder: '0.125rem solid #bad2ff',
                    boxBorder: '#bad2ff',
                    boxOpacity: '1',
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default FirstLinkedBed;
